export class UnableToLinkPollActivityException extends Error {
  constructor() {
    super('Unable to link Poll activity since it has no play step')
  }
}
